import { render, staticRenderFns } from "./Related.vue?vue&type=template&id=ceaca84a&scoped=true&"
import script from "./Related.vue?vue&type=script&lang=js&"
export * from "./Related.vue?vue&type=script&lang=js&"
import style0 from "./Related.vue?vue&type=style&index=0&id=ceaca84a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceaca84a",
  null
  
)

export default component.exports